import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import TopBar from './Components/TopBar';
import 'bootstrap/dist/css/bootstrap.min.css'; // Required for Bootstrap styling

import HeroSlider from './Components/HeroSlider';
import ProductCards from './Components/ProductCards';
import FooterSection from './Components/FooterSection';

import CardDetail from './Components/CardDetail';
import ImageDetail from './Components/ImageDetail';

function App() {
  return (
    <Router>
      <TopBar />
      
      <HeroSlider />

      <Routes>
        {/* Home Page */}
        <Route path="/" element={<ProductCards />} />

        {/* Card Detail Page */}
        <Route path="/card/:id" element={<CardDetail />} />

        {/* Category Image Detail Page */}
        <Route path="/card/:id/category/:imgId" element={<ImageDetail />} />
      </Routes>

      <FooterSection />
    </Router>
  );
}

export default App;